import legacyConfigurations from './legacyConfigurations';
import mapping from './mapping';

const root = {
	legacyConfigurations,
	mapping
};

export default root;
